import React from 'react';
import { Badge } from '@dev-go4ellis/go4-design-system';
import './Testimonials.scss';

const LOGOS = [
  { label: 'Youth Sports League' },
  { label: 'State University' },
  { label: 'Regional Tournament' },
  { label: 'Community Center' },
  { label: 'High School District' },
];

const QUOTES = [
  {
    body: 'The pricing is exactly what they say it is. No surprises on the invoice, no negotiation. We estimate, we post, we pay.',
    attrib: 'Athletic Director, Regional Sports Complex',
  },
  {
    body: 'We used to spend hours calling agencies for quotes. With Go4 we know the number before we post.',
    attrib: 'Event Coordinator, Youth Tournament Circuit',
  },
];

const Testimonials = () => (
  <section className="pl-testi">
    <div className="pl-testi__inner">
      <div className="pl-testi__badge">
        <Badge variant="soft" color="info" size="sm">TRUSTED BY</Badge>
      </div>

      <h2 className="pl-testi__title">
        Organizers across youth sports, schools, colleges and community events
      </h2>

      <div className="pl-testi__logos">
        {LOGOS.map((l) => (
          <div key={l.label} className="pl-testi__logo">{l.label}</div>
        ))}
      </div>

      <div className="pl-testi__quotes">
        {QUOTES.map((q) => (
          <blockquote key={q.attrib} className="pl-testi__quote">
            <p className="pl-testi__body">"{q.body}"</p>
            <cite className="pl-testi__attrib">— {q.attrib}</cite>
          </blockquote>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
